<template>
  <div class="radio-container">
    <label v-for="option in options" :key="option.value" class="radio-label">
      <input type="radio" :value="option.value" v-model="selectedOption" :id="option.value" :name="name"
        :disabled="option.disabled" />
      <span class="custom-radio"></span>
      <span class="texts">{{ option.label }} <span v-if="option.info" class="info">{{ option.info }}</span></span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'RadioButtons',
  props: {
    options: {
      type: Array,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    modelValue: {
      type: String,
      default: "pdf",
    },
  },
  computed: {
    selectedOption: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.radio-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 2rem;

  label {
    margin: 0;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    cursor: pointer;

    input {
      display: none;
    }

    .custom-radio {
      width: 1.5rem;
      height: 1.5rem;
      border: 2px solid #bfbfbf;
      border-radius: 50%;
      background-color: transparent;
      transition: all 0.1s ease;
      display: inline-block;
      position: relative;
    }

    input:checked+.custom-radio {
      border-color: #122350;
    }

    input:checked+.custom-radio::after {
      content: "";
      position: absolute;
      top: 0.25rem;
      left: 0.25rem;
      width: 0.75rem;
      height: 0.75rem;
      background-color: #122350;
      border-radius: 50%;
    }

    &:hover .custom-radio {
      border-color: #122350;
    }

    input:disabled+.custom-radio {
      border-color: #d3d3d3;
      background-color: #f0f0f0;
    }

    input:disabled:checked+.custom-radio {
      border-color: #d3d3d3;
    }

    input:disabled:checked+.custom-radio::after {
      background-color: #d3d3d3;
    }

    &:has(input:disabled) {
      cursor: not-allowed;
    }

    .texts {
      font-size: 1rem;
      font-weight: 600;
      color: #000;

      .info {
        font-weight: 400;
        color: #979797;
      }
    }
  }
}
</style>